import apiMiddleware from "../api/apiMiddleware";

export const attractionBookings = async (page = 1, search = "") => {
  try {
    const response = await apiMiddleware.get(
      `/attraction-bookings-supplier?page=${page}${search ? `&search=${search}` : ""}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

